import { createAssetPluginFactory, fromAddEthereumChainParameterToFactoryParams, } from '@exodus/ethereum-api';
import { DYNAMIC_EVMS_CONFIG } from './config.js';
export const dynamicEvmChains = DYNAMIC_EVMS_CONFIG.map(({ assetName, combinedAssetName, chainInfo, isTestnet = false, feeData }) => {
    const assetPlugin = createAssetPluginFactory(fromAddEthereumChainParameterToFactoryParams({
        ...chainInfo,
        isTestnet,
        feeData,
    }));
    return {
        assetPlugin,
        assetName,
        combinedAssetName,
    };
});
const dynamicEvmAssetPlugins = Object.fromEntries(dynamicEvmChains.map(({ assetPlugin }) => [assetPlugin.name, assetPlugin]));
// Example: "astar" -> "evm0xec0"
export const DYNAMIC_EVM_CHAIN_NAME_TO_ASSET_NAME = Object.fromEntries(dynamicEvmChains.map(({ assetPlugin, assetName }) => [
    assetName,
    assetPlugin.name,
]));
export default dynamicEvmAssetPlugins;
